module.exports = __webpack_public_path__ + "img/107.8.38b0f9f2.png";